import script from "./ReleaseNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&setup=true&lang=js"

import "./ReleaseNotes.vue?vue&type=style&index=0&id=7ade1736&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../Users/kmg/Documents/VS Code/Classwork/poker-session-tracker-vue3/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ade1736"]])

export default __exports__